import { get, set, remove } from './storage'

const KEY = 'ACCOUNTS_TRANSIENTS_ERROS'

const getTransientError = () =>
  get(KEY)
    .then(value => {
      remove(KEY)
      return value
    })
    .catch(() => null)

const setTransientError = value => {
  set(KEY, value)
}

export default {
  get: getTransientError,
  set: setTransientError,
}
